<template>
    <footer class="flex justify-center footer-box">
        <div class="footer-bg flex justify-center">
            <div
                v-for="(item, i) in footerList"
                :key="'footerList' + i"
                class="footer-item"
                @click="goCarouselItem(item.index, i)">
                <img class="img" :src="i == atIndex ? item.atIcon : item.icon" alt="" />
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            // index: 0,
            atIndex: 0,
			footerList: [
				{
					index: 0,
					icon: require('@/assets/images/computility/footer-1.png'),
					atIcon: require('@/assets/images/computility/footer-1-at.png')
				},
				{
					index: 1,
					icon: require('@/assets/images/computility/footer-2.png'),
					atIcon: require('@/assets/images/computility/footer-2-at.png')
				},
				// {
				// 	index: 2,
				// 	icon: require('@/assets/images/computility/footer-3.png'),
				// 	atIcon: require('@/assets/images/computility/footer-3-at.png')
				// }
			]
        }
    },
    // computed: {
    //     atIndex() {
    //         let { query } = this.$route
    //         return parseInt(query.index || 0, 10)
    //     }
    // },
    mounted() {
        console.log(this.$route.name)
        let { query } = this.$route
        this.atIndex = parseInt(query.index || 0, 10)
    },
    methods: {
		goCarouselItem(index, i) {
            this.atIndex = i
            this.$emit('carouselAt', index)
		}
    }
}
</script>

<style lang="scss" scoped>
.footer-box {
    position: fixed;
    width: 100%;
    height: 150px;
    bottom: 0;
    z-index: 11;
    left: 50%;
    transform: translate(-50%, 0);
	@keyframes breath_light {
	    0% {
	        filter: brightness(90%);
	    }
	    50% {
	        filter: brightness(140%);
	    }
	    100% {
	        filter: brightness(90%);
	    }
	}
    // .footer-bgBox {
    //     width: 100%;
    //     height: 100%;
    //     background-image: radial-gradient(circle at 50% 100%, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
    // }
    .footer-bg {
		animation: breath_light 3s ease infinite;
        width: 100%;
        height: 100%;
        // background: url('~@/assets/images/exposition/footer.png') no-repeat center center;
        // background-size: 100% 100%;
        // padding-top: 10px;
        .footer-item {
            transition: all .5s;
            width: 	254px;
            height: 73px;
            margin: 0 35px;
            cursor: pointer;
            position: relative;
            &:hover {
                transform: scale(1.2) translate(0, -10%);
            }
            .img {
                position: absolute;
                top: 10px;
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>